var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay select-product", class: _vm.position },
    [
      _vm.steep == 1
        ? _c("div", { staticClass: "steep1" }, [
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t("dash.post-creator.overlay.select-product-instruction")
                )
              ),
            ]),
            _vm.productsSelect.length
              ? _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "list-item hide-scrollbar" },
                    [
                      false ? _c("span", { staticClass: "loader" }) : _vm._e(),
                      _vm._l(_vm.productsSelect, function (product) {
                        return _c(
                          "div",
                          { key: product.id, staticClass: "item" },
                          [
                            _c("img", {
                              attrs: {
                                src: product.image
                                  ? product.image
                                  : "img/avatar.jpg",
                                alt: "",
                              },
                            }),
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "username" }, [
                                _vm._v(_vm._s(product.text)),
                              ]),
                            ]),
                            _c("i", {
                              staticClass: "fa-regular fa-xmark",
                              on: {
                                click: function ($event) {
                                  return _vm.removeProduct(product.id)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ])
        : _vm.steep == 2
        ? _c("div", { staticClass: "steep2" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "containerInput" }, [
                _c("div", { staticClass: "input" }, [
                  _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.textSearchShop,
                        expression: "textSearchShop",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t(
                        "dash.post-creator.overlay.search-shop"
                      ),
                    },
                    domProps: { value: _vm.textSearchShop },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.sendSearchShops.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.textSearchShop = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              !_vm.textSearchShop.length
                ? _c("p", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.post-creator.overlay.suggested-shops")
                      )
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _vm.stateLoader
                    ? _c("span", { staticClass: "loader" })
                    : _vm.shops.length || !_vm.textSearchShop
                    ? _vm._l(
                        !_vm.textSearchShop ? _vm.shopsDefault : _vm.shops,
                        function (shop) {
                          return _c(
                            "div",
                            {
                              key: shop.id,
                              staticClass: "item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectShop(shop)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: shop.image
                                    ? shop.image
                                    : "img/avatar.jpg",
                                  alt: "",
                                },
                              }),
                              _c("div", { staticClass: "info" }, [
                                _c("p", { staticClass: "username" }, [
                                  _vm._v(_vm._s(shop.text)),
                                ]),
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.post-creator.overlay.shop-label"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }
                      )
                    : _c("p", { staticClass: "no-result" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dash.post-creator.overlay.no-shop"))
                        ),
                      ]),
                ],
                2
              ),
            ]),
          ])
        : _vm.steep == 3
        ? _c("div", { staticClass: "steep3" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "container-input" }, [
                _c(
                  "div",
                  {
                    staticClass: "back-btn",
                    on: {
                      click: function ($event) {
                        _vm.steep = 2
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
                ),
                _c("div", { staticClass: "input" }, [
                  _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.textSearchProduct,
                        expression: "textSearchProduct",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t(
                        "dash.post-creator.overlay.search-product"
                      ),
                    },
                    domProps: { value: _vm.textSearchProduct },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.sendSearchProducts.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.textSearchProduct = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              !_vm.textSearchProduct.length
                ? _c("p", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.post-creator.overlay.suggested-products")
                      )
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _vm.stateLoader
                    ? _c("span", { staticClass: "loader" })
                    : _vm.products.length || !_vm.textSearchProduct
                    ? _vm._l(
                        !_vm.textSearchProduct
                          ? _vm.productsDefault
                          : _vm.products,
                        function (product) {
                          return _c(
                            "div",
                            {
                              key: product.id,
                              staticClass: "item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectProduct(product)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: product.image
                                    ? product.image
                                    : "img/avatar.jpg",
                                  alt: "",
                                },
                              }),
                              _c("div", { staticClass: "info" }, [
                                _c("p", { staticClass: "username" }, [
                                  _vm._v(_vm._s(product.text)),
                                ]),
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(_vm._s(product.description)),
                                ]),
                              ]),
                            ]
                          )
                        }
                      )
                    : _c("p", { staticClass: "no-result" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dash.post-creator.overlay.no-product"))
                        ),
                      ]),
                ],
                2
              ),
            ]),
          ])
        : _vm.steep == 4
        ? _c("div", { staticClass: "steep4" }, [
            _c("div", { staticClass: "content" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(_vm.$t("dash.post-creator.overlay.variant-choice"))
                ),
              ]),
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _vm.stateLoader
                    ? _c("span", { staticClass: "loader" })
                    : _vm._l(_vm.variantsProduct, function (variant) {
                        return _c(
                          "div",
                          {
                            key: variant.id,
                            staticClass: "item",
                            on: {
                              click: function ($event) {
                                return _vm.selectVariant(variant)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: variant.image
                                  ? variant.image
                                  : "img/avatar.jpg",
                                alt: "",
                              },
                            }),
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "username" }, [
                                _vm._v(_vm._s(variant.number)),
                              ]),
                            ]),
                          ]
                        )
                      }),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "btn-secondary",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("dash.button.close")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }